//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { DepartmentNotFoundMessage } from './department-not-found.message';

@PresenterType(
{
    model: DepartmentNotFoundMessage
})
@Component({
    selector: 'department-not-found-message-template',
    templateUrl: './department-not-found-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DepartmentNotFoundMessageTemplateComponent
{
    public data: WritableSignal<DepartmentNotFoundMessage>;
    
    constructor() {
        this.data = signal<DepartmentNotFoundMessage>(null);
    }
}